module.exports = __webpack_public_path__ + "bb1eff864c2d9e44d3a03d0012bc40b0.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/amalia-ulman.gif
 ** module id = 378
 ** module chunks = 0
 **/